var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonusesIsNotAvailableInfo"
  }, [_c('img', {
    staticClass: "bonusesIsNotAvailableInfo__info",
    attrs: {
      "src": require("@/assets/images/svg/info-gray.svg"),
      "alt": "Внимание"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bonusesIsNotAvailableInfo__text",
    class: [{
      bonusesIsNotAvailableInfo__text_off: !_vm.active
    }]
  }, [_vm._v("\n    " + _vm._s(_vm.active ? 'Оплата бонусами недоступна для товаров со знаком' : 'В корзине нет товаров, которые можно оплатить бонусами') + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }